<div class="main-container">

  <div class="title">
    <span class="title-text">Occupancy Statistics</span>

    <p class="small-title">
      Select a date to fetch occupancy statistics.
    </p>
  </div>

  <div class="searchBar">

    <div class="each-div">
      <span class="drop-title">Date</span>

      <input
        type="date"
        class="text-box-active"
        [formControl]="occupancyDate"
      />
    </div>

    <div class="btn">
      <button
        type="button"
        class="ac-secondary-btn"
        (click)="reset()">
        Reset
      </button>

      <button
        type="button"
        class="ac-primary-btn"
        (click)="searchOccupancy()">
        Search
      </button>
    </div>

  </div>

  <!-- REGULAR CATEGORY -->

  @if(regularData.length > 0){

  <div class="category-title">
    Booking Category : Regular
  </div>

  <div class="occupancy-table">

    <div class="table-header">

      <div class="date-col">
        Date Range
      </div>

      <div class="stats-col">
        <div class="heading">
          Individual
        </div>

        <div class="sub-heading">
          Booking Count | Guest Count
        </div>
      </div>

      <div class="stats-col">
        <div class="heading">
          Family
        </div>

        <div class="sub-heading">
          Booking Count | Guest Count
        </div>
      </div>

      <div class="stats-col">
        <div class="heading">
          Bulk
        </div>

        <div class="sub-heading">
          Booking Count | Guest Count
        </div>
      </div>

      <div class="stats-col total-column">
        <div class="heading">
          Total
        </div>

        <div class="sub-heading">
          Booking Count | Guest Count
        </div>
      </div>

    </div>

    @for(item of regularData; track item){

    <div class="table-row">

      <div class="date-col">
        {{item.from_date}} → {{item.to_date}}
      </div>

      <div class="stats-col">
        {{item.individual.bookingCount}}
        |
        {{item.individual.guestCount}}
      </div>

      <div class="stats-col">
        {{item.family.bookingCount}}
        |
        {{item.family.guestCount}}
      </div>

      <div class="stats-col">
        {{item.bulk.bookingCount}}
        |
        {{item.bulk.guestCount}}
      </div>

      <div class="stats-col total-column">
        {{item.total.bookingCount}}
        |
        {{item.total.guestCount}}
      </div>

    </div>

    }

  </div>

  }

  <!-- UTSAV CATEGORY -->

  @if(utsavData.length > 0){

  <div class="category-title">
    Booking Category : Utsav
  </div>

  <div class="occupancy-table">

    <div class="table-header">

      <div class="date-col">
        Date Range
      </div>

      <div class="stats-col">
        <div class="heading">
          Individual
        </div>

        <div class="sub-heading">
          Booking Count | Guest Count
        </div>
      </div>

      <div class="stats-col">
        <div class="heading">
          Family
        </div>

        <div class="sub-heading">
          Booking Count | Guest Count
        </div>
      </div>

      <div class="stats-col">
        <div class="heading">
          Bulk
        </div>

        <div class="sub-heading">
          Booking Count | Guest Count
        </div>
      </div>

      <div class="stats-col total-column">
        <div class="heading">
          Total
        </div>

        <div class="sub-heading">
          Booking Count | Guest Count
        </div>
      </div>

    </div>

    @for(item of utsavData; track item){

    <div class="table-row">

      <div class="date-col">
        {{item.from_date}} → {{item.to_date}}
      </div>

      <div class="stats-col">
        {{item.individual.bookingCount}}
        |
        {{item.individual.guestCount}}
      </div>

      <div class="stats-col">
        {{item.family.bookingCount}}
        |
        {{item.family.guestCount}}
      </div>

      <div class="stats-col">
        {{item.bulk.bookingCount}}
        |
        {{item.bulk.guestCount}}
      </div>

      <div class="stats-col total-column">
        {{item.total.bookingCount}}
        |
        {{item.total.guestCount}}
      </div>

    </div>

    }

  </div>

  }

  <!-- GRAND TOTAL -->

  @if(grandTotal){

  <div class="divider"></div>

  <div class="grand-total-section">

    <div class="grand-total-title">
      Grand Total
    </div>

    <div class="grand-total-content">

      <div class="grand-total-item">
        <span class="grand-label">
          Date
        </span>

        <span class="grand-value">
          {{grandTotal.date}}
        </span>
      </div>

      <div class="grand-total-item">
        <span class="grand-label">
          Booking Count
        </span>

        <span class="grand-value">
          {{grandTotal.bookingCount}}
        </span>
      </div>

      <div class="grand-total-item">
        <span class="grand-label">
          Guest Count
        </span>

        <span class="grand-value">
          {{grandTotal.guestCount}}
        </span>
      </div>

    </div>

  </div>

  }

</div>